import Navbar from "../components/Navbar";
import LoginCard from "../components/AuthCard/Login/LoginCard";
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom"; 
  import hero2 from '../assets/public/hero/desktop2.jpg' 
  
export default function CreateAccount() {

 
	return (
		<Box>

			<Navbar />
			<Box
				mx="auto"
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				flexDirection={{ xs: "column", md: "row" }}
			>
				<Box
					sx={{
						width: { xs: "100%", md: "50%" },
						display: { xs: "block", md: "block" },
						backgroundImage: `url(${hero2})`,
						backgroundSize: "cover",
						backgroundPosition: { xs: "center center", md: "center center" },
						height: { xs: "150px", md: "calc(100vh - 85px)" },
					}}
				>

				</Box>
				<Box maxWidth="550px" mx="auto" pt="2rem" px="1rem">


					<Typography variant="h4" mb="0.5rem">Sign in</Typography>
					<Typography variant="p">Access your Romingo rewards, manage your reservations, and receive special deals and offers by booking hotels.</Typography>
					<br />
					<br />
					<LoginCard />
					<Link
						variant="contained"
						size="large"
						color="primary"
						to="/reset-password"
					>
						<Typography
							variant="body2"
							sx={{
								color: "", mt: 2,
								textAlign: "center",
							}}
						>Forgot Your Password?</Typography>

					</Link>
					<Box sx={{
						display: "flex",
						justifyContent: "center",
						gap: 2
					}}>
						<Typography
							variant="body2"
							sx={{
								color: "text.secondary",
								mt: 1, textAlign: "center",
							}}>
							Not a member ?
						</Typography>
						<Link
							variant="contained"
							size="large"
							color="primary"
							to="/create-account"
						>
							<Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
								Create Your Account
							</Typography>
						</Link>
					</Box>
				</Box>
			</Box>
		</Box>)
} 